/**
 * useTenantConfig - TanStack Query wrapper for GET /getTenantConfig.
 *
 * Canonical query key ['tenant-config', tenantSlug] so every consumer
 * shares one cache entry. Tenant config is near-static per session; the
 * 10-minute staleTime mirrors the lookup-picker pattern
 * (LOOKUP_STALE_MS in SuggestResourceForm).
 */

import { useQuery } from '@tanstack/react-query';
import { tenantConfigApi } from '@/lib/tenantConfig';

const TENANT_CONFIG_STALE_MS = 10 * 60 * 1000;

/** The one cache key every tenant-config reader shares. */
export function tenantConfigQueryKey(tenantSlug: string): readonly unknown[] {
  return ['tenant-config', tenantSlug];
}

export function useTenantConfig(
  tenantSlug: string,
  { enabled = true }: { enabled?: boolean } = {},
) {
  return useQuery({
    queryKey: tenantConfigQueryKey(tenantSlug),
    queryFn: ({ signal }) => tenantConfigApi.get(tenantSlug, signal),
    enabled,
    staleTime: TENANT_CONFIG_STALE_MS,
  });
}
